import { Lightbox } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useState } from "react";
import { Fullscreen } from "yet-another-react-lightbox/plugins";
import { images } from "./masonry.js";

export default function CorporateEventsGallery() {
  const [open, setOpen] = useState(false);
  const [lightboxIndex, setIndex] = useState();
  const [selectedFilter, setSelectedFilter] = useState("Всички");

  // Example categories for filtering
  const categories = ["Всички", "Студио", "Behind The Scenes"];

  // Filter images based on the selected filter
  const filteredImages =
    selectedFilter === "Всички"
      ? images
      : images.filter((img) => img.category === selectedFilter);

  return (
    <div className="page__width flex justify-center flex-col">
      {/* Filter Menu */}
      <div className="flex flex-wrap gap-4 mb-8 justify-center">
        {categories.map((category, index) => (
          <button
            key={index}
            className={`px-4 py-2 rounded-full border ${
              selectedFilter === category
                ? "bg-black text-white"
                : "bg-gray-200 text-black"
            }`}
            onClick={() => setSelectedFilter(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Masonry Grid */}
            <div className="masonry page__width">
                {filteredImages.map((img, index) => (
                    <div
                        className={`masonry_item rounded-xl`}
                        key={index}
                        onClick={() => {
                            setIndex(index);
                            setOpen(true);
                        }}
                    >
                        <img
                            src={img.src}
                            loading="lazy"
                            alt={`masonry ${index}`}
                            className="w-full h-full object-fit rounded-[inherit]"
                        />
                    </div>
                ))}
                <Lightbox
                    open={open}
                    index={lightboxIndex}
                    close={() => setOpen(false)}
                    slides={images}
                    plugins={[Fullscreen]}
                />
            </div>
        </div>
    );
}